import { useQuery } from 'react-query';
import {
  getMembersWithLeastPhotoCards,
  type MembersWithLeastPhotoCardsResponse
} from '../../services/memberService';
import { MEMBERS_QUERY_KEYS } from '../queryKeys';

export function useGetMembersWithLeastPhotoCards() {
  return useQuery<MembersWithLeastPhotoCardsResponse, Error>(
    MEMBERS_QUERY_KEYS.membersWithLeastPhotoCards,
    getMembersWithLeastPhotoCards
  );
}
